const initialState = {
  resultsMarketingList: [],
  resultsMarketing: {},
  resultsMarketingAdd: {},
  resultsMarketingPatch: {},
  resultsMarketingDelete: {},
};

const reducer = (state = initialState, action) => {
  const newState = { ...state };

  switch (action.type) {
    case "LIST_MARKETING_RESPONSE_GET":
      newState.resultsMarketingList = action.value;
      break;
    case "MARKETING_RESPONSE_GET":
      newState.resultsMarketing = action.value;
      break;
    case "MARKETING_RESPONSE_RESET":
      newState.resultsMarketingAdd = {};
      newState.resultsMarketingPatch = {};
      newState.resultsMarketingDelete = {};
      newState.resultsMarketingList = [];
      newState.resultsMarketing = {};
      break;
    case "MARKETING_RESPONSE_ADD":
      newState.resultsMarketingAdd = action.value;
      break;
    case "MARKETING_RESPONSE_UPDATE":
      newState.resultsMarketingPatch = action.value;
      break;
    case "MARKETING_RESPONSE_DELETE":
      newState.resultsMarketingDelete = action.value;
      break;
    case "RESET_MARKETING_RESPONSES":
      newState.resultsMarketingAdd = {};
      newState.resultsMarketingPatch = {};
      newState.resultsMarketingDelete = {};
      newState.resultsMarketingList = [];
      newState.resultsMarketing = {};
      break;
    default:
      break;
  }
  return newState;
};

export default reducer;
